<template>
  <div>
    <div>
      <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading>
    </div>
    <!-- <md-stepper md-alternate-labels>
      <md-step
        md-label="Shipping summary"
        :md-editable="stepperWidget.quotationId=='' || stepperWidget.quotationId==null?true:false"
        :md-icon="stepperWidget.quotationId=='' || stepperWidget.quotationId==null?'':'done'"
      ></md-step>
      <md-step
        md-alternate-labels
        md-label="Assignment Order"
        :md-editable="stepperWidget.assignId=='' || stepperWidget.assignId==null?true:false"
        :md-disabled="stepperWidget.assignId=='' || stepperWidget.assignId==null?true:false"
        :md-icon="stepperWidget.assignId=='' || stepperWidget.assignId==null?'':'done'"
      ></md-step>
      <md-step
        md-label="Vehicle Booking"
        :md-editable="stepperWidget.vehicleBookingId=='' || stepperWidget.vehicleBookingId==null?true:false"
        :md-icon="stepperWidget.vehicleBookingId=='' || stepperWidget.vehicleBookingId==null?'':'done'"
      ></md-step>
      <md-step
        md-label="GRN Detail "
        :md-editable="stepperWidget.followActivityId=='' || stepperWidget.followActivityId==null?true:false"
        :md-icon="stepperWidget.followActivityId=='' || stepperWidget.followActivityId==null?'':'done'"
      ></md-step>
      <md-step
        md-label="Invoice"
        :md-editable="stepperWidget.invoiceId=='' || stepperWidget.invoiceId==null?true:false"
        :md-icon="stepperWidget.invoiceId=='' || stepperWidget.invoiceId==null?'':'done'"
        :md-active="stepperWidget.invoiceId=='' || stepperWidget.invoiceId==null?true:false"
      ></md-step>
    </md-stepper>-->
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousGoods" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Transport Billing Invoice Form</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button style="font-size: 0.675rem; margin-left: 5px" @click="
                proceedAssignmentProforma(
                  invoiceList.allModuleId,
                  0,
                  invoiceList.bookingNo
                )
                " size="sm" class="ml-1" variant="outline-info">Proceed To Proforma</b-button>
              <!-- :disabled="$sessionsStorage.get('nameUser') != 'Bhavneesh'?true:false" -->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <banner-component :allModuleIdBanner="this.invoiceList.allModuleId ? this.invoiceList.allModuleId : ''
          " :jobSeriesBanner="this.invoiceList.bookingNo ? this.invoiceList.bookingNo : ''" :bannerClientName="this.invoiceList.shippingCustomerName
            ? this.invoiceList.shippingCustomerName
            : ''
            " iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <h4 class="mt-3 error" v-if="sentForApproval == '1' && chnageApprovalStatus != '1'">
              Invoice Sent For Approval
            </h4>

            <div class="box" v-if="PreviousPerformaList.length > 0">
              <div class="box-body row">
                <div class="col-md-2" v-for="(pre_item, pre_index) in PreviousPerformaList" :key="pre_index">
                  <b-button style="font-size: 0.675rem" class="mt-2" v-if="pre_item.profarmaSeries" size="sm"
                    @click="getPreviousTallyData(pre_item)" variant="info">
                    <b>{{ pre_item.profarmaSeries }}</b>
                  </b-button>
                </div>
              </div>
            </div>
            <!-- {{invoiceList}} -->
            <md-layout md-gutter>
              <md-layout md-flex="45">
                <md-layout md-flex="100">
                  <label>Sales Booking No.</label>
                  <b-form-input :formatter="capitalizeAll" v-model="invoiceList.bookingNo" disabled></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <label for="containerTypeId">Invoice Status</label>
                <model-list-select :list="invoiceStatusList" v-model="invoiceForm.invoiceStatus" option-value="inv"
                  option-text="int" placeholder="Select Status"></model-list-select>
              </md-layout>
            </md-layout>
            <md-layout md-gutter style="margin-top: 10px">
              <md-layout md-flex="45">
                <md-layout md-flex="100">
                  <label>Shipper/Customer Name</label>
                  <b-form-input :formatter="capitalizeAll" v-model="invoiceList.shippingCustomerName"
                    disabled></b-form-input>
                </md-layout>
              </md-layout>

              <!-- <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Shipper/Customer Contact</label>
                  <b-form-input :formatter="capitalizeAll" v-model="invoiceList.shipperCustomerContact" disabled></b-form-input>
                </md-layout>
              </md-layout>-->
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Invoice Date</label>
                  <b-form-input :formatter="capitalizeAll" name="Date" id="Date" v-model="invoiceForm.Date"
                    disabled></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <!-- <md-layout md-gutter style="margin-top:10px">
    
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <label>Shipper/Customer address</label>
                  <b-form-textarea :formatter="capitalizeAll" v-model="invoiceList.customerAddress" disabled></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>-->
            <md-layout md-gutter style="margin-top: 10px">
              <md-layout md-flex="45">
                <md-layout md-flex="100">
                  <label>Pickup Location</label>
                  <b-form-input :formatter="capitalizeAll" v-model="invoiceList.fromLocation" disabled></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <md-layout md-flex="100">
                  <label>Handover Location</label>
                  <b-form-input :formatter="capitalizeAll" v-model="invoiceList.toLocation" disabled></b-form-input>
                </md-layout>
              </md-layout>

              <!-- <md-layout md-flfsdfex="5"></md-layout>
          <md-layout md-flex="25">
            <md-layout md-flex="100">
              <label>ICD Name</label>
              <b-form-input :formatter="capitalizeAll" v-model="invoiceList.icdName" disabled></b-form-input>
            </md-layout>
              </md-layout>-->
            </md-layout>

            <!-- <md-layout md-gutter style="margin-top:10px">
            
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <label>Transportation Goods Details</label>
                  <b-form-textarea :formatter="capitalizeAll" v-model="invoiceList.transportDetail" disabled></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>-->

            <!-- <hr class="hr-border">

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <h4>Job Type:</h4>
        </md-layout>
        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout
            v-for="(showJobTypeVal, index) in showJobType"
            :key="index"
            :md-flex="showJobTypeVal.flex"
          >
            <md-checkbox
              disabled
              v-model="invoiceList.JobType[index]"
              class="md-primary"
              :md-value="showJobTypeVal.value"
              :name="'JobType'+(index+1)"
              :id="'JobType'+(index+1)"
            >{{ showJobTypeVal.show }}</md-checkbox>
          </md-layout>
        </md-layout>
            -->
            <!-- <md-layout md-gutter class="gutr">
             
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <label>Other Details</label>
                  <b-form-textarea :formatter="capitalizeAll" v-model="invoiceList.otherDetail" disabled></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>-->

            <!-- <md-layout md-gutter class="gutr">
              <md-layout md-flex="55"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Transport Charge(Per Vehicle)</label>
                  <b-form-input :formatter="capitalizeAll"
                    name="quoteSalesCost"
                    id="quoteSalesCost"
                    v-model="invoiceList.quoteSalesCost"
                    disabled
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!invoiceList.totalInvoiceCost">{{totalInvoiceCostError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Transport Charge({{invoiceList.noOfTrucks}} Vehicle)</label>
                  <b-form-input :formatter="capitalizeAll"
                    name="quoteSalesCost"
                    id="quoteSalesCost"
                    v-model="invoiceList.totalInvoiceCost"
                    disabled
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!invoiceList.totalInvoiceCost">{{totalInvoiceCostError}}</span>
              </md-layout>
            </md-layout>-->

            <div class="gutr">
              <h5>
                <b-badge variant="info">GRN Details</b-badge>
              </h5>
              <div class="box-body">
                <table id="quotationDetail" class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>GRN Number</th>
                      <th>Container Number & Type</th>
                      <th>Fuel Slip No.</th>
                      <th>Vehicle No</th>
                      <th>S-Line Seal No.</th>
                      <th>Custom Seal No.</th>
                      <th>Transportation By</th>
                      <th>Transporter Name</th>
                      <th>Date</th>
                    </tr>
                    <tr v-for="(item, index) in TPTGRNDATA" :key="index">
                      <td>{{ item.GRNSeries }}</td>

                      <td>
                        {{ item.containerNo }}
                        <br />
                        {{ item.multipleContainerType }}
                      </td>
                      <td>{{ item.FuelSlipNo }}</td>
                      <td>{{ item.vehicleNo }}</td>
                      <td>{{ item.slineSealNo }}</td>
                      <td>{{ item.customSealNo }}</td>
                      <td>{{ item.tptType == 1 ? "Pridel" : "OutSourced" }}</td>
                      <td>
                        {{ item.transporterName == "" ? "NA" : item.transporterName }}
                      </td>
                      <td>
                        <span>Loading Date :{{ item.Date | moment }}</span>
                        <br />
                        <span> Reporting Date :{{ item.factoryInDate | moment }} </span>
                        <br />
                        <span> Released Date :{{ item.factoryOutDate | moment }} </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- this.invoiceList.bookingNo -->
            <Profit-Loss v-if="invoiceList.allModuleId" :PMS_fk_all_module_id="invoiceList.allModuleId"
              :PMS_jb_series="invoiceList.bookingNo" :PMS_fk_client_id="invoiceList.clientName"
              :PLAccordianStatus="false" :PLAccordianButton="true" />
            <Assignment-Timeline :TMAccordianStatus="false" :TMAccordianButton="true"
              :allModuleId="Number(invoiceList.allModuleId)" />
            <Payment-Summary v-if="invoiceList.allModuleId" :PMS_fk_all_module_id="invoiceList.allModuleId"
              :PMS_jb_series="invoiceList.bookingNo" :PMS_fk_client_id="invoiceList.clientName" />
            <OldExpenseAdditionalTask
              v-if="invoiceList.allModuleId"
              :allModuleId="invoiceList.allModuleId"
              :type="'additional-task'"
            />
            <h5 class="mt-3">
              <b-badge variant="info">Charges</b-badge>
            </h5>
            <div class="mt-3">
              <h5>
                <span class="error mt-4">
                  Note : Approval will be required when Selling Rate is less than
                  Quotation Rate.!
                </span>
              </h5>
              <br />
              <span class="error mt-1">* marked heads are mandatory..!</span>
            </div>
            <table id="quotationDetail" class="table mt-3 table-light table-bordered">
              <thead>
                <tr>
                  <th>
                    <b-button size="sm" variant="success" @click="addQuotationFields">
                      <md-icon>add</md-icon>
                    </b-button>
                  </th>

                  <th style="width: 600px !important">Particulars</th>
                  <th style="width: 300px !important">Container Type</th>
                  <th style="width: 50px !important">Quantity</th>
                  <th style="width: 250px !important">Quotation Rate</th>
                  <th style="width: 250px !important">Selling Rate</th>

                  <th>Invoice Amount(Without Taxes)</th>
                  <th>Unit</th>
                  <th style="width: 600px !important">Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in quotationData" :key="index">
                  <td>
                    <b-button size="sm" variant="danger" @click="removeCol(index)">
                      <md-icon>remove</md-icon>
                    </b-button>
                  </td>
                  <!-- <td>{{index+1}}</td> -->
                  <td>
                    <model-list-select :isDisabled="chnageApprovalStatus == '1' && !item.tptTableId ? true : false
                      " :list="$store.getters['common/getAllLedgerList']" v-model="item.otherCharge"
                      option-value="ledger" option-text="ledger" placeholder="Select Particular">
                    </model-list-select>
                    <!-- <model-list-select
                      :isDisabled="
                        chnageApprovalStatus == '1' && !item.tptTableId ? true : false
                      "
                      :list="ledgerData"
                      v-model="item.otherCharge"
                      option-value="ledger"
                      option-text="ledger"
                      placeholder="Select Type"
                    ></model-list-select> -->
                  </td>
                  <td>
                    <model-list-select :isDisabled="chnageApprovalStatus == '1' && !item.tptTableId ? true : false
                      " :list="containerMasterData" v-model="item.containerType" option-value="containerType"
                      option-text="containerType" placeholder="Select Type"></model-list-select>
                    <!-- <b-form-input :formatter="capitalizeAll"
                      :disabled="item.tptTableId!=''?true:false"
                      v-model="item.containerType"
                    ></b-form-input>-->
                  </td>

                  <td>
                    <b-form-input :formatter="capitalizeAll" :disabled="chnageApprovalStatus == '1' && !item.tptTableId ? true : false
                      " @input="getFinalAmount(index)" type="number" v-model="item.quantity"></b-form-input>
                  </td>

                  <td>
                    <b-form-input :formatter="capitalizeAll" disabled  type="number"
                      v-model="item.byInPrice"></b-form-input>
                  </td>
                  <td>
                    <!-- :disabled="chnageApprovalStatus == '1' && !item.tptTableId ? true : false" -->
                    <b-form-input :formatter="capitalizeAll" type="number" @input="getFinalAmount(index)" v-model="item.qRate"></b-form-input>
                  </td>

                  <td>
                    <b-form-input :formatter="capitalizeAll" :disabled="chnageApprovalStatus == '1' && !item.tptTableId ? true : false
                      " type="number" v-model="item.invoiceAmount"></b-form-input>
                  </td>
                  <td>
                    <model-list-select :isDisabled="chnageApprovalStatus == '1' && !item.tptTableId ? true : false
                      " :list="unitList" v-model="item.unit" option-value="unitId" option-text="unitName"
                      placeholder="Select"></model-list-select>
                  </td>
                  <td>
                    <b-form-input :formatter="capitalizeAll" v-model="item.remark"></b-form-input>
                  </td>
                </tr>
              </tbody>
            </table>

            <md-layout md-gutter class="mrgtop-2per">
              <md-layout md-flex="50">
                <b-button v-if="validateTally == false && this.sentForApproval != '1'" class="mt-3" variant="primary"
                  @click="submitInvoice('1')" id="addButtonLoader" :disabled="DisableSubmit == '0' &&
                    $store.getters['common/getAllSuccessInvoiceTB'].InvoiceTypeKeyFlag ==
                    true
                    ? true
                    : false
                    ">
                  {{
                    invoiceForm.invoiceStatus == "0"
                      ? "Save & Send To Billing"
                      : "Save & Submit"
                  }}
                </b-button>
                <span v-if="updateTime != 'null' && editUserName != 'null'" style="
                    mmargin-top: auto;
                    margin-bottom: auto;
                    padding-top: 20px;
                    margin-left: 20px;
                  ">
                  Last Updated At :
                  <span style="color: red">{{ updateTime }}</span> , By :
                  <span style="color: red">{{ editUserName }}</span>
                  <br />
                  <div v-if="
                    $store.getters['common/getAllSuccessInvoiceTB']
                      .BillingSeriesDataString
                  ">
                    Invoice No.
                    <span style="color: red">{{
                      $store.getters["common/getAllSuccessInvoiceTB"]
                        .BillingSeriesDataString
                    }}</span>
                    genrated.
                    <span v-if="
                      $store.getters['common/getAllSuccessInvoiceTB']
                        .InvoiceTypeKeyFlag == true
                    ">Cannot be re-submitted</span>
                  </div>
                </span>
                <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="20">
                <!-- ' $store.getters["common/getAllSuccessInvoiceTB"]==true -->
                <b-button :disabled="DisableSubmit == '0' &&
                  $store.getters['common/getAllSuccessInvoiceTB'] == true
                  ? true
                  : false
                  " class="mt-3" v-if="validateTally == true && this.sentForApproval != '1'" variant="dark"
                  @click="submitInvoice('2')">Send For Approval</b-button>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose"
      ref="addPop"></md-dialog-confirm>
  </div>
</template>

<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import BannerComponent from "../../allModuleForm/bannerComponent.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import PaymentSummary from "../../common/paymentSummary.vue";
import ProfitLoss from "../../common/profitLoss.vue";
import AssignmentTimeline from "../../common/assignmentTimeline.vue";
import OldExpenseAdditionalTask from "../../allModuleForm/components/OldExpenseAdditionalTask.vue";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllLedgerList",
      JSON.stringify({
        itemCode: "LedgerList",
        JobType: this.$route.query.JobType,
        ShipmentType: this.$route.query.ShipmentType,
        ModuleType: this.$route.query.ModuleType,
        isLedgerActive: '1',
      })
    );
    if (
      globalPermissionStatus("Transportation") &&
      this.$sessionsStorage.get("storeQuotationId") != undefined &&
      this.$sessionsStorage.get("storeQuotationId") != "" &&
      this.$sessionsStorage.get("salesBookingId") != undefined &&
      this.$sessionsStorage.get("salesBookingId") != "" &&
      this.$sessionsStorage.get("storefollowActivityId") != undefined &&
      this.$sessionsStorage.get("storefollowActivityId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/invoice/");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      updateTime: "null",
      editUserName: "null",
      sentForApproval: "",
      validateTally: "",
      chnageApprovalStatus: "",

      validSubmit: "",
      isLoading: false,
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
          this.$sessionsStorage.get("PermissionStatus") !== undefined &&
          this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "0",
          int: "Closed",
        },
      ],
      unitList: [],
      invoiceList: {
        tollPrice: "",
        allModuleId: "",
        bookingNo: "",
        noOfTrucks: "",
        icdName: "",
        icdAddress: "",
        jobType: [],
        JobType: [],
        billingPartyName: "",
        otherDetail: "",
        fromLocation: "",
        toLocation: "",
        shippingCustomerName: "",
        shipperCustomerContact: "",
        customerAddress: "",
        transportDetail: "",
        totalInvoiceCost: "",
        quoteSalesCost: "",
        amountPaid: "",
      },
      ledgerData: [],
      containerMasterData: [],
      TPTGRNDATA: [],
      PreviousPerformaList: [],

      stepperWidget: {},
      alert: {
        content: "a",
        ok: "ok",
      },
      DisableSubmit: "",
      allModuleIdUpdate: "",
      invoiceForm: {
        invoiceStatus: "1",
        allModuleId: "",
        quotationData: [],
        invoiceId: "",
        date: "",
        status: "",
        amountPaid: "",
        clientId: this.$sessionsStorage.get("clientId"),
        quotationId: this.$sessionsStorage.get("storeQuotationId"),
        vehicleBookingId: this.$sessionsStorage.get("storeVehicleBookingId"),
        salesBookingId: this.$sessionsStorage.get("salesBookingId"),
        assignId: this.$sessionsStorage.get("storeAssignId"),
        followActivityId: this.$sessionsStorage.get("storefollowActivityId"),
        goodRecievedId: this.$sessionsStorage.get("storeGenerateGrn"),
      },
      viewPartialPayment: [],

      totalInvoiceCostError: "",
      quotationData: [],
      validateInvoice: true,

      showJobType: [],
      value1: "",
      pendingAmount: "",
    };
  },

  mounted() { },
  beforeDestroy() { },
  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    BannerComponent,
    PaymentSummary,
    ProfitLoss,
    AssignmentTimeline,
    OldExpenseAdditionalTask,
  },
  computed: {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  methods: {
    proceedAssignmentProforma(all_module_id, isConsolidation, mainSalesSeries) {
      // newContainerFlow,
      this.$sessionsStorage.set("editSalesExId", all_module_id);
      if (isConsolidation == "1") {
        console.log("Consolidation");
        this.$router.push({
          path: "/consolidation/viewBillingDetails/" + all_module_id,
          query: { mainSalesSeries: mainSalesSeries },
        });
      } else {
        this.$router.push({
          path: "/common/assignmentPerforma/" + all_module_id,
        });
      }
    },
    getFinalAmount(ind) {
      if (!this.quotationData[ind].quantity) {
        this.quotationData[ind].quantity = 1;
      }
      let count = 0;
      console.log(this.quotationData[ind].invoiceAmount);
      this.quotationData[ind].invoiceAmount =
        parseInt(this.quotationData[ind].quantity) *
        parseInt(this.quotationData[ind].qRate);

      for (let i = 0; i < this.quotationData.length; i++) {
        if (
          this.quotationData[i].qRate &&
          this.quotationData[i].byInPrice != "Charges As Per Receipt" &&
          this.quotationData[i].byInPrice != "" &&
          this.quotationData[i].byInPrice != undefined
        ) {
          if (
            parseInt(this.quotationData[i].qRate) >=
            parseInt(this.quotationData[i].byInPrice)
          ) {
            //  count++;
            console.log("iu");
            this.validateTally = false;
          } else {
            // console.log(x.ccSellingRate,"tyrt")
            this.validateTally = true;
            break;
            return false;
          }
        }
      }
      // this.quotationData.map((x, index) => {
      //   if (x.quantity != "") {
      //     let finalAmt = parseInt(x.quantity) * parseInt(x.qRate);
      //     x.invoiceAmount = finalAmt;
      //   }
      // });
    },
    removeCol(index) {
      this.quotationData.splice(index, 1);
    },
    addQuotationFields() {
      let tableFields = {
        otherCharge: "",
        containerType: "",
        quantity: "",
        byInPrice: "",
        qRate: "",
        unit: "",
        invoiceAmount: "",
        remark: "",
        tptTableId: "1",
      };

      this.quotationData.push(tableFields);
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    validateInvoiceForm() {
      let validate_new = true;

      if (validate_new != true) {
        this.validateInvoice = false;
      } else {
        this.validateInvoice = true;
      }
    },

    onClose(type) {
      // if (type != "cancel") {
      //   this.$router.push({
      //     path: "/listView/viewInvoice"
      //   });
      // }
    },

    submitInvoice(id) {
      this.invoiceForm["buttonId"] = id;
      this.invoiceForm["quotationData"] = this.quotationData;
      this.invoiceForm["bookingNo"] = this.invoiceList.bookingNo;

      this.validateInvoiceForm();
      for (let r = 0; r < this.quotationData.length; r++) {
        if (
          !this.quotationData[r].otherCharge ||
          !this.quotationData[r].quantity ||
          !this.quotationData[r].qRate ||
          !this.quotationData[r].unit ||
          !this.quotationData[r].invoiceAmount 
          // ||
          // !this.quotationData[r].currency ||
          // !this.quotationData[r].byInPrice
        ) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Invoice Amount in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.quotationData[r].quantity) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Invoice Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.quotationData[r].qRate) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Invoice Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.quotationData[r].unit) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Invoice Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.quotationData[r].invoiceAmount) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Invoice Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else {
          console.log("All fields are Entered");
        }

        // else if (!this.quotationData[r].currency) {
        //   this.alert.content =
        //     "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Invoice Amount,Currency in Charges Section";
        //   this.$refs["addPop"].open();
        //   return false;
        //   break;
        // }
      }

      let total = 0;

      this.quotationData.map((x) => {
        let dummy = parseInt(x.invoiceAmount) + total;
        total = dummy;
      });

      this.invoiceForm["amount"] = total;

      let vehicleInvAmt = total / 2;

      this.invoiceForm["amountPerVehicle"] = vehicleInvAmt;
      this.invoiceForm.allModuleId = this.allModuleIdUpdate;

      if (this.validateInvoice != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Transport/addInvoice.php`,
          data: JSON.stringify(this.invoiceForm),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    previousGoods() {
      window.history.go(-1);
      // if (globalPermissionStatus("VehicleBookingFollow") != "Disabled") {
      //   if (this.invoiceForm.invoiceId == "") {
      //     this.$sessionsStorage.set(
      //       "PermissionStatus",
      //       globalPermissionStatus("VehicleBookingFollow")
      //     );
      //     this.$router.push({
      //       path: "/vehicle/vehicleBooking"
      //     });
      //   } else {
      //     this.$router.push({
      //       path: "/listView/viewInvoice"
      //     });
      //   }
      // } else {
      //   alert("You Don't Have permission for vehicle Booking");
      // }
    },
    getData() {
      this.doLoading();
      this.quotationData = [];
      this.showJobType = [
        {
          value: "FF",
          show: "FF",
          flex: "10",
        },
        {
          value: "CC",
          show: "CC",
          flex: "10",
        },
        {
          value: "Trucking",
          show: "Trucking",
          flex: "15",
        },

        {
          value: "Yard",
          show: "Yard",
          flex: "10",
        },
        {
          value: "All",
          show: "All",
          flex: "10",
        },
      ];
      let currentDate = new Date();
      let payload = {
        salesBookingId: this.$sessionsStorage.get("salesBookingId"),
        quotationId: this.$sessionsStorage.get("storeQuotationId"),
        clientId: this.$sessionsStorage.get("clientId"),
        assignId: this.$sessionsStorage.get("storeAssignId"),
        vehicleBookingId: this.$sessionsStorage.get("storeVehicleBookingId"),
        allModuleId: this.invoiceList.allModuleId,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/viewInvoice.php`,
        data: JSON.stringify(payload),

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            let TParti = [];
            let TCon = [];
            let TSelO = [];
            let TSF = [];
            let TINV = [];
            let TCUR = [];
            let TRE = [];
            let QUN = [];
            let UN = [];
            this.pendingAmount = data.pendingAmount;

            this.stepperWidget = data.arrayWidget;
            this.viewPartialPayment = data.invoicePaymentArray;

            Object.keys(data.invoiceList[0]).map((x) => {
              this.invoiceList[x] = data.invoiceList[0][x] || "";
              if (x == "jobType") {
                this.invoiceList[x] = data.invoiceList[0][x].split(",");
              }
            });
            if (data.PreviousPerformaList.length > 0) {
              this.PreviousPerformaList = data.PreviousPerformaList;
            }
            if (data.invoiceList.length > 0) {
              this.allModuleIdUpdate = data.invoiceList[0].allModuleId;
              this.invoiceForm.allModuleId = data.invoiceList[0].allModuleId;
              this.invoiceList.allModuleId = data.invoiceList[0].allModuleId;
              this.invoiceList.bookingNo = data.invoiceList[0].bookingNo;
              this.invoiceList.shippingCustomerName =
                data.invoiceList[0].shippingCustomerName;
            }
            if (data.users && data.users.length > 0) {
              this.editUserName = data.users[0].employeeName;
              this.updateTime = data.invoiceArray[0].updateTime;
            }

            if (
              this.$sessionsStorage.get("clientId") != "" ||
              this.$sessionsStorage.get("clientId") != null
            ) {
              this.invoiceForm.Date = this.formatDate(currentDate);
            }
            let here = [];
            this.showJobType.map((x, index) => {
              let i = this.invoiceList.jobType.indexOf(x.value);

              i >= 0
                ? (this.invoiceList.JobType[index] = true)
                : (this.invoiceList.JobType[index] = false);
            });

            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }

            if (data.unitList.length > 0) {
              this.unitList = data.unitList;
            } else {
              this.unitList = [];
            }

            if (data.containerMasterData.length > 0) {
              this.containerMasterData = data.containerMasterData;
            } else {
              this.containerMasterData = [];
            }
            if (data.TPTGRNDATA.length > 0) {
              this.TPTGRNDATA = data.TPTGRNDATA;
            } else {
              this.TPTGRNDATA = [];
            }

            if (data.invoiceArray.length > 0) {
              this.DisableSubmit = data.invoiceArray[0].invoiceStatus;
              this.sentForApproval = data.invoiceArray[0].sentForApproval;
              this.chnageApprovalStatus = data.invoiceArray[0].chnageApprovalStatus;
              Object.keys(data.invoiceArray[0]).map((x) => {
                if (x == "particulars") {
                  if (data.invoiceArray[0][x] != null) {
                    TParti = data.invoiceArray[0][x].split(",");
                  } else {
                    TParti = [];
                  }
                } else if (x == "containerType") {
                  if (data.invoiceArray[0][x] != null) {
                    TCon = data.invoiceArray[0][x].split(",") || [];
                  } else {
                    TCon = [];
                  }
                } else if (x == "quotationRate") {
                  if (data.invoiceArray[0][x] != null) {
                    TSelO = data.invoiceArray[0][x].split(",") || [];
                  } else {
                    TSelO = [];
                  }
                } else if (x == "sellingRateFinal") {
                  if (data.invoiceArray[0][x] != null) {
                    TSF = data.invoiceArray[0][x].split(",") || [];
                  } else {
                    TSF = [];
                  }
                } else if (x == "unit") {
                  if (data.invoiceArray[0][x] != null) {
                    UN = data.invoiceArray[0][x].split(",") || [];
                  } else {
                    UN = [];
                  }
                } else if (x == "finalRateWithoutTax") {
                  if (data.invoiceArray[0][x] != null) {
                    TINV = data.invoiceArray[0][x].split(",") || [];
                  } else {
                    TINV = [];
                  }
                } else if (x == "remark") {
                  if (data.invoiceArray[0][x] != null) {
                    TRE = data.invoiceArray[0][x].split(",") || [];
                  } else {
                    TRE = [];
                  }
                } else if (x == "quantity") {
                  if (data.invoiceArray[0][x] != null) {
                    QUN = data.invoiceArray[0][x].split(",") || [];
                  } else {
                    QUN = [];
                  }
                } else {
                  this.invoiceForm[x] = data.invoiceArray[0][x] || "";
                }
              });
              if (TParti.length > 0) {
                console.log(TSF);
                TParti.map((x, index) => {
                  let obj = {
                    otherCharge: x,
                    containerType: TCon[index],
                    quantity: QUN[index],
                    byInPrice: TSelO[index],
                    qRate: TSF[index],
                    unit: UN[index],
                    invoiceAmount: TINV[index],

                    remark: TRE[index],
                  };

                  this.quotationData.push(obj);
                });
              }
              // Object.keys(data.invoiceArray[0]).map(x => {
              //   if (x != "status" && x != "amountPaid") {
              //     this.invoiceForm[x] = data.invoiceArray[0][x] || "";
              //   }
              // });
            } else {
              //  if (data.quotationData.length > 0) {
              // let tableFields = {
              //   otherCharge: "TRANSPORT CHARGES",
              //   containerType: "NA",
              //   quantity: this.invoiceList.noOfTrucks,
              //   byInPrice: this.invoiceList.quoteSalesCost,
              //   qRate: this.invoiceList.quoteSalesCost,
              //   invoiceAmount: this.invoiceList.quoteSalesCost,
              //   remark: "",
              //   tptTableId: "main"
              // };

              // this.quotationData.push(tableFields);

              // let tableFields2 = {
              //   otherCharge: "TOLL CHARGES",
              //   containerType: "NA",
              //   quantity: this.invoiceList.noOfTrucks,
              //   byInPrice: this.invoiceList.tollPrice,
              //   qRate: this.invoiceList.tollPrice,
              //   invoiceAmount: this.invoiceList.tollPrice,
              //   remark: "",
              //   tptTableId: "main"
              // };

              // this.quotationData.push(tableFields2);
              data.quotationData.map((x) => {
                this.quotationData.push(x);
              });
              // this.quotationData = data.quotationData;
              //  }
            }
            if (this.allModuleIdUpdate) {
              this.$store.dispatch(
                "common/setAllSuccessInvoiceTB",
                JSON.stringify({
                  itemCode: "ALL_SUCCESS_INVOICE_TALLY_BILLING",
                  allModuleId: this.allModuleIdUpdate,
                  InvoiceTypeKey: "T",
                })
              );
            }
            // alert(this.$store.getters["common/getAllSuccessInvoiceTB"])
            this.doLoadingClose();
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getPreviousTallyData(pre_item) {
      console.log("pre_item=>", pre_item);
      // this.ffInvoiceModal.fromAgentColoderTable = pre_item.fromAgentColoderTable;
      // this.ffInvoiceModal.invoiceForClient = pre_item.invoiceForClient;
      // this.ffInvoiceModal.otherChargeFF = pre_item.otherChargeFF;
      // this.ffInvoiceModal.profarmaLocationId = pre_item.profarmaLocationId;
      // this.ffInvoiceModal.profarmaLocationName = pre_item.profarmaLocationName;
      // this.ffInvoiceModal.shipperInvNoforTally = pre_item.shipperInvNoforTally;
      // this.ffInvoiceModal.shipperInvDateforTally = pre_item.shipperInvDateforTally;
      // this.ffInvoiceModal.shipperInvNo = pre_item.shipperInvNo;
      // this.ffInvoiceModal.shipperInvDate = pre_item.shipperInvDate;
      // this.ffInvoiceModal.stateName = pre_item.stateName;
      // this.ffInvoiceModal.clientgst = pre_item.clientgst;
      // this.ffInvoiceModal.grnNo = pre_item.grnNo;
      // this.ffInvoiceModal.pickup = pre_item.pickup;
      // this.ffInvoiceModal.Handover = pre_item.Handover;
      // this.ffInvoiceModal.factoryLoc = pre_item.factoryLoc;
      // // this.ffInvoiceModal.jobType= pre_item.jobTypeNameArr;
      // // this.ffInvoiceModal.jobTypeName= pre_item.jobTypeNameArr;
      // this.ffInvoiceModal.jobNo = pre_item.jobNo;
      // this.ffInvoiceModal.ffExportFclId = pre_item.ffExportFclId;
      // this.ffInvoiceModal.allModuleId = pre_item.allModuleId;
      // this.ffInvoiceModal.ccTypeExImp = pre_item.ccTypeExImp;
      // this.ffInvoiceModal.weight = pre_item.weight;
      // this.ffInvoiceModal.vessel = pre_item.vessel
      //   ? pre_item.vessel
      //   : this.ffInvoiceModal.vessel;
      // this.ffInvoiceModal.blNo = pre_item.blNo;
      // this.ffInvoiceModal.BOE = pre_item.BOE;
      // this.ffInvoiceModal.clientId = pre_item.clientId;
      // this.ffInvoiceModal.clientName = pre_item.clientName;
      // this.ffInvoiceModal.contact = pre_item.contact;
      // this.ffInvoiceModal.adress = pre_item.adress;
      // this.ffInvoiceModal.POR = pre_item.POR;
      // this.ffInvoiceModal.LP = pre_item.LP;
      // this.ffInvoiceModal.POD = pre_item.POD;
      // this.ffInvoiceModal.FPOD = pre_item.FPOD;
      // this.ffInvoiceModal.shippingLine = pre_item.shippingLine;
      // let BLno = this.ffInvoiceModal.blNo.replace(/ /g, "").split(",");
      // console.log("BLno", BLno);
      // BLno = [...new Set(BLno)];
      // console.log("BLno", BLno);
      // this.ffInvoiceModal.blNo = "";
      // this.ffInvoiceModal.blNo = BLno.join(",");
      // console.log("pre_item", pre_item);
      this.getBillData(pre_item);
    },
    getBillData(item) {
      this.quotationData = [];
      // Object.keys(this.ffInvoiceModal).map((x, index) => {
      //   if(x!=null && x!=undefined){
      //   this.ffInvoiceModal[x] = item[x];
      //   }
      // });

      let TParti = [];
      let TCon = [];
      let TSelO = [];
      let TSF = [];
      let TINV = [];
      let TCUR = [];
      let TRE = [];
      let QUN = [];
      let UN = [];

      if (item.particulars != null) {
        TParti = item.particulars.split(",");
      }
      if (item.containerType != null) {
        TCon = item.containerType.split(",");
      }
      if (item.quantity != null) {
        QUN = item.quantity.split(",");
      }
      if (item.quotationRate != null) {
        TSF = item.quotationRate.split(",");
      }
      if (item.sellingRateFinal != null) {
        TSelO = item.sellingRateFinal.split(",");
      }
      if (item.unit != null) {
        UN = item.unit.split(",");
      }
      if (item.finalRateWithoutTax != null) {
        TINV = item.finalRateWithoutTax.split(",");
      }
      if (item.currency != null) {
        TCUR = item.currency.split(",");
      }
      if (item.remark != null) {
        TRE = item.remark.split(",");
      }

      if (TParti.length > 0) {
        TParti.map((x, index) => {
          let obj1 = {
            otherCharge: x,
            containerType: TCon[index],
            quantity: QUN[index],
            qRate: TSelO[index],
            byInPrice: TSF[index],
            unit: UN[index],
            invoiceAmount: TINV[index],
            currency: TCUR[index],
            remark: TRE[index],
          };

          this.quotationData.push(obj1);

          // this.CCCheckDone = 1;
        });

        console.log("this.quotationData=>", this.quotationData);

        // this.revisedSavedBillingData = this.ffTallyInvoiceData;
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");
      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },
  },
};
</script>
<style scoped>
.md-direction-bottom-right {
  width: 18% !important;
}

.mrgtop-2per {
  margin-top: 1%;
}

.mrgtop-5px {
  margin-top: 4%;
}

.mrgtop-5px {
  margin-top: 4%;
}

.center {
  text-align: center;
}

.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.md-button-color {
  background-color: #607d8d !important;
}

.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// invoice.vue?6c2197e6